import React from "react";

const Button = (props) => {
  const {
    ctaText,
    id = "",
    onClick = () => {},
    onMouseOver = () => {},
    icon = " ",
    className = "",
    titleName = "",
    disabled = false,
    actionCtaText = "",
    badge = "",
    isLoading,
    dataTip,
    dataFor,
  } = props;
  return (
    <button
      onClick={onClick}
      onMouseOver={onMouseOver}
      id={id}
      className={className}
      title={titleName}
      disabled={disabled}
      data-tip={dataTip}
      data-for={dataFor}
    >
      {actionCtaText ? actionCtaText : ctaText}
    
      {badge}
      {icon}

    </button>
  );
};

export default Button;
